import AmexGDAB2BTestimonials from './AmexGDAB2BTestimonials';

export default AmexGDAB2BTestimonials;
